import { i18n } from 'invision-core';
import CustomerCareLocaleKeys from '../locales/keys';
import transaction from './templates/transaction.pug';
export var transactionDetails = function transactionDetails(data) {
  var labels = i18n.translateObject(CustomerCareLocaleKeys.PRINT_VIEWS.TRANSACTION_DETAILS);
  return transaction(Object.assign({
    data: data,
    labels: labels
  }));
};